module.exports = __webpack_public_path__ + "img/sponser-6.41fb4052.png";